import { RouteType } from "types/RouteType";
import { routesWithAuth } from "../routing/authRoutes";
import estimatingRoutesList from "./estimating/estimatingRoutesList";
import { generateServiceViewRoutes } from "../routing/ServiceViewRouteGenerator";
import serviceStores from "../serviceStoresConfig";

// Generate dynamic service view routes
const serviceViewRoutes = generateServiceViewRoutes(serviceStores);

const routesList: RouteType[] = [
  ...routesWithAuth,
  ...estimatingRoutesList,
  ...serviceViewRoutes, // Add generated service view routes
];

export default routesList;
